import { TeamColorsValues } from './common.type';

export enum Lang {
  EN = 'en',
  ES = 'es',
  FR = 'fr',
}
export type LangValues = `${Lang}`;

export enum Displays {
  LANDSCAPE = 'landscape',
  PORTRAIT = 'portrait',
}
export type DisplaysValues = `${Displays}`;

export type Pick = {
  team: TeamColorsValues;
  index: number;
};

export type FetchReturnType<T> = Promise<T>;

export type LogsStatus = { win: boolean; tries: number };

export type DbDraft = {
  data: string;
  dateCreation: Date;
};
export type DbLogs = {
  data: string;
  status: LogsStatus;
  dateCreation: Date;
};

export type Icons = 'cogs' | 'draft' | 'logs' | 'inbox';

export enum Sizes {
  M = 'M',
  L = 'L',
  XL = 'XL',
}

export type SizesValues = `${Sizes}`;
